<template>
    <document-head title="Settings"/>

    <app-layout>
        <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
            <div class="p-6 bg-white border-b border-gray-200">
                <form @submit.prevent="submitName">
                    <div>
                        <BreezeLabel for="name" value="Change Username"/>
                        <BreezeInput id="name" type="text" class="mt-1 block w-full" v-model="formName.name" required autofocus autocomplete="username"/>
                    </div>

                    <div class="mt-4">
                        <BreezeLabel for="name_current_password" value="Current Password"/>
                        <BreezeInput id="name_current_password" type="password" class="mt-1 block w-full" v-model="formName.password" required autocomplete="current-password"/>
                    </div>

                    <BreezeButton class="mt-4 px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150" :class="{ 'opacity-25': formName.processing }" :disabled="formName.processing">
                        Save
                    </BreezeButton>
                </form>
            </div>
        </div>
        <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg mt-4">
            <div class="p-6 bg-white border-b border-gray-200">
                <form @submit.prevent="submitEmail">
                    <div>
                        <BreezeLabel for="email" value="Change Email"/>
                        <BreezeInput id="email" type="email" class="mt-1 block w-full" v-model="formEmail.email" required autofocus autocomplete="email"/>
                    </div>

                    <div class="mt-4">
                        <BreezeLabel for="email_current_password" value="Current Password"/>
                        <BreezeInput id="email_current_password" type="password" class="mt-1 block w-full" v-model="formEmail.password" required autocomplete="current-password"/>
                    </div>

                    <BreezeButton class="mt-4 px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150" :class="{ 'opacity-25': formEmail.processing }" :disabled="formEmail.processing">
                        Save
                    </BreezeButton>
                </form>
            </div>
        </div>
        <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg mt-4">
            <div class="p-6 bg-white border-b border-gray-200">
                <form @submit.prevent="submitPassword">
                    <div class="mt-4">
                        <BreezeLabel for="current_password" value="Current Password"/>
                        <BreezeInput id="current_password" type="password" class="mt-1 block w-full" v-model="formPassword.password" required autocomplete="current-password"/>
                    </div>

                    <div class="mt-4">
                        <BreezeLabel for="new_password" value="New Password"/>
                        <BreezeInput id="new_password" type="password" class="mt-1 block w-full" v-model="formPassword.new_password" required autocomplete="new-password"/>
                    </div>

                    <div class="mt-4">
                        <BreezeLabel for="confirm_password" value="Confirm New Password"/>
                        <BreezeInput id="confirm_password" type="password" class="mt-1 block w-full" v-model="formPassword.new_password_confirmation" required autocomplete="confirm-password"/>
                    </div>

                    <BreezeButton class="mt-4 px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150" :class="{ 'opacity-25': formPassword.processing }" :disabled="formPassword.processing">
                        Save
                    </BreezeButton>
                </form>
            </div>
        </div>

        <template #footer>
            <div class="text-center text-sm text-gray-500 mx-8">
                <div class="flex items-center">
                    Crafted with
                    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                         stroke-width="2" viewBox="0 0 24 24" class="mx-1 -mt-px w-4 h-4 text-red-500">
                        <path
                            d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
                    </svg>
                    By
                    <a href="https://bird.cafe" class="ml-1 underline">Bird Cafe</a>
                    <span>&nbsp;|&nbsp;</span>
                    <a href="https://patreon.com/seebeyond" class="underline" style="color:#FF424D;">Support us on Patreon!</a>
                    <span>&nbsp;|&nbsp;</span>
                    <ILink href="/" class="underline">Home Page</ILink>
                </div>
            </div>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/App'
import {Head as DocumentHead} from '@inertiajs/inertia-vue3';
import BreezeButton from "@/Components/Button";
import BreezeCheckbox from "@/Components/Checkbox";
import BreezeInput from "@/Components/Input";
import BreezeLabel from "@/Components/Label";
import BreezeValidationErrors from "@/Components/ValidationErrors";
import {Link as ILink} from "@inertiajs/inertia-vue3"

export default {
    components: {
        ILink,
        BreezeButton,
        BreezeCheckbox,
        BreezeInput,
        BreezeLabel,
        BreezeValidationErrors,
        AppLayout,
        DocumentHead,
    },
    props: {
        name: String,
        email: String,
    },
    data() {
        return {
            formName: this.$inertia.form({
                name: this.$page.props.auth.user.name,
                password: '',
                type: 0
            }),
            formEmail: this.$inertia.form({
                email: this.$page.props.auth.user.email,
                password: '',
                type: 1
            }),
            formPassword: this.$inertia.form({
                password: '',
                new_password: '',
                new_password_confirmation: '',
                type: 2
            })
        }
    },
    methods: {
        submitName() {
            this.formName.post(this.route('tig::users.update'), {
                onFinish: () => this.formName.reset('password'),
            })
        },
        submitEmail() {
            this.formEmail.post(this.route('tig::users.update'), {
                onFinish: () => this.formEmail.reset('password'),
            })
        },
        submitPassword() {
            this.formPassword.post(this.route('tig::users.update'), {
                onFinish: () => this.formPassword.reset('password'),
            })
        }
    }
}
</script>
